/* #93 J'ADORE · koszyk premium (8.10.2026).
   1) Karta „Dodano do koszyka” po dodaniu z karty produktu (zamiast samoczynnego otwarcia szuflady; szuflada dalej pod ikoną koszyka).
   2) Prezenty: wybór kafelka → atrybut koszyka „Prezent 600” / „Prezent 1500”; spadek poniżej progu czyści wybór; „Prezent” = 1 / 2 (ERP).
   3) „Pokochały też” / „Sprawdź, co pokochały inne”: rekomendacje.json (Obroty, ERP) → Shopify Recommendations → marka → bestsellery,
      bez Lira Clinical / Osmosis Beauty, prezentów, bonów i usług; w koszyku najpierw produkty domykające najbliższy próg.
   Stan progów liczy Liquid (snippets/jadore-prezenty-pasek.liquid, data-jk-cfg); tu tylko rysowanie, zapis atrybutów i przeliczenie walut.
   assets/cart.js i theme.js bez zmian: słuchamy zdarzeń motywu (product-ajax:added, pubsub cartUpdate). */
(() => {
  if (window.__jk93) return;
  window.__jk93 = true;

  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  const cfgEl = () => { const a = $$('script[data-jk-cfg]'); return a[a.length - 1]; };
  let ostatni = null;
  const cfg = () => { const el = cfgEl(); if (!el) return ostatni; try { ostatni = JSON.parse(el.textContent); } catch (e) {} return ostatni; };
  const C0 = cfg();
  if (!C0) return;
  // routes.root_url to „/” albo „/en” (bez ukośnika na końcu): ujednolicamy do „/en/”
  const ROOT = String(C0.root || '/').replace(/\/?$/, '/');
  const T = () => (cfg() || C0).t;
  const OK = '<i class="jk-ok">✓</i>';
  const zloty = s => String(s).replace('✓', OK);
  const kurs = c => (c.waluta === 'PLN' ? 1 : parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1);
  // Kwoty bez groszy, gdy pełne. Format motywu (moneyFormat) jest złotówkowy, więc poza PLN formatujemy walutą koszyka (Intl).
  const kwota = cents => {
    const c = cfg() || C0;
    let s;
    if (c.waluta && c.waluta !== 'PLN') {
      try { s = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: c.waluta }).format(Math.round(cents) / 100); } catch (e) {}
    }
    if (!s) {
      try { s = FoxTheme.utils.formatMoney(Math.round(cents), FoxTheme.settings.moneyFormat); } catch (e) { s = (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' zł'; }
    }
    // R4: poza PLN separator dziesiętny taki jak w kwotach Shopify na tej stronie („€145,90”), żeby nie mieszać „€145.90” i „€145,90”
    if (s && c.waluta && c.waluta !== 'PLN') { const wz = document.querySelector('.totals__subtotal-value, .cart-item .price'); if (wz && /\d,\d{2}(?!\d)/.test(wz.textContent)) s = s.replace(/[.,]/g, m => (m === '.' ? ',' : '.')); }
    s = String(s).replace(/([,.])00(?=\D*$)/, '');
    // R2: polski zapis „1500 zł” (format sklepu daje „1.500 zł”)
    return c.waluta && c.waluta !== 'PLN' ? s : s.replace(/(\d)\.(?=\d{3}(\D|$))/g, '$1');
  };
  // R2: nazwa bez powtórzonej marki („Bioelements Barrier Fix…” pod „BIOELEMENTS” → „Barrier Fix…”)
  const bezMarki = (tytul, marka) => {
    const t = String(tytul || ''), m = String(marka || '').trim();
    if (!m || t.toLowerCase().indexOf(m.toLowerCase()) !== 0) return t;
    const r = t.slice(m.length).replace(/^[\s\-–—:·]+/, '');
    return r.length > 2 ? r : t;
  };
  // R2: poza PLN progi zaokrąglone w górę do pełnej jednostki waluty (€140, nie €139.79)
  const progW = (c, r, x) => (c.waluta === 'PLN' ? x : Math.ceil((x * r) / 100) * 100);
  const stan = c => {
    const r = kurs(c), p1 = progW(c, r, c.prog1), p2 = progW(c, r, c.prog2);
    return { r, p1, p2, okD: c.kraj === 'PL' && c.waluta === 'PLN' && c.d >= c.progD, ok1: c.p >= p1, ok2: !!c.prog2on && c.p >= p2, pl: c.kraj === 'PL' && c.waluta === 'PLN' };
  };

  /* ---------- atrybuty koszyka ---------- */
  const lokalne = {};
  const attr = (c, k) => (k in lokalne ? lokalne[k] : (c.attr || {})[k] || '');
  let zapis = Promise.resolve();
  const zapiszAttr = zmiany => {
    Object.assign(lokalne, zmiany);
    Object.entries(zmiany).forEach(([k, v]) => $$(`input[data-jk-attr="${k}"]`).forEach(i => { i.value = v; }));
    zapis = zapis.then(() => fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: zmiany }) })).catch(() => {});
    return zapis;
  };
  const synchronizuj = () => {
    if (C0.giftLines) return; // Gift controller owns attributes, after verified cart writes.
    const c = cfg();
    if (!c || !c.promo) return;
    const s = stan(c);
    const chce = c.n > 0 ? {
      Prezent: s.ok2 ? '2' : s.ok1 ? '1' : '',
      'Prezent 600': s.ok1 ? attr(c, 'Prezent 600') : '',
      'Prezent 1500': s.ok2 ? attr(c, 'Prezent 1500') : '',
    } : { Prezent: '', 'Prezent 600': '', 'Prezent 1500': '' };
    const zm = {};
    Object.keys(chce).forEach(k => { if (chce[k] !== attr(c, k)) zm[k] = chce[k]; });
    // inputy formularza kasy zawsze zgodne ze stanem (kasa wysyła je razem z koszykiem)
    Object.entries(chce).forEach(([k, v]) => $$(`input[data-jk-attr="${k}"]`).forEach(i => { i.value = v; }));
    if (Object.keys(zm).length) zapiszAttr(zm);
  };

  /* ---------- poza PLN: przeliczenie progów kursem w zarezerwowanym miejscu ---------- */
  const przelicz = () => {
    if (C0.giftLines) return;
    const c = cfg();
    if (!c || !c.promo || c.waluta === 'PLN') return;
    const s = stan(c), t = c.t;
    $$('[data-jk-slot=postep][data-jk-js]').forEach(el => {
      let klucz, a = c.p, cel;
      if (c.p < s.p1) { klucz = 'postep_1'; cel = s.p1; } else if (s.ok2 || !c.prog2on) { klucz = c.prog2on ? 'masz_dwa' : 'masz_prezent'; } else { klucz = 'postep_2'; cel = s.p2; }
      el.querySelector('.jk-postep__tekst').innerHTML = zloty(t[klucz]).replace('{P}', '<b>' + kwota(a) + '</b>').replace('{T}', cel ? kwota(cel) : '');
      el.classList.toggle('jk-postep--pelny', !cel);
      const tor = el.querySelector('.jk-postep__tor>span');
      if (tor) tor.style.setProperty('--jk-w', cel ? Math.min(1, a / cel).toFixed(3) : 1);
      el.hidden = !(c.n > 0 && c.p > 0);
    });
    $$('[data-jk-slot=prezenty][data-jk-js]').forEach(el => {
      $$('.jk-kafel[data-jk-wybor="600"]', el).forEach(k => {
        if (s.ok1) { k.removeAttribute('aria-disabled'); k.removeAttribute('tabindex'); } else { k.setAttribute('aria-disabled', 'true'); k.setAttribute('tabindex', '-1'); k.setAttribute('aria-pressed', 'false'); }
        if (s.ok1) k.setAttribute('aria-pressed', String(k.dataset.jkWartosc === attr(c, 'Prezent 600')));
      });
      const st = el.querySelector('[data-jk-status="600"]');
      if (st) st.innerHTML = s.ok1 ? (attr(c, 'Prezent 600') ? t.wybrany_1.replace('{N}', '<b>' + esc(nazwa(attr(c, 'Prezent 600'))) + '</b>') : esc(t.wybierz)) : t.dodaj_wybierz.replace('{X}', '<b>' + kwota(s.p1 - c.p) + '</b>');
      const dr = el.querySelector('[data-jk-drobne="600"]');
      if (dr) dr.hidden = !s.ok1 || !!attr(c, 'Prezent 600');
    });
    // „Zyskujesz” poza PLN: bez dostawy (tylko PL), prezent, krem (kwota przeliczona kursem), rabat; suma tylko z realnych kwot
    $$('[data-jk-slot=zysk][data-jk-js]').forEach(el => {
      const li = [], krem = s.ok2 ? Math.round(c.krem * s.r) : 0, suma = c.save + krem;
      if (s.ok1) li.push('<li data-jk-zysk-prezent>' + OK + esc(t.prezent_gratis.replace('{N}', attr(c, 'Prezent 600') ? nazwa(attr(c, 'Prezent 600')) : t.do_wyboru)) + '</li>');
      if (s.ok2) li.push('<li>' + OK + esc(t.krem_gratis.replace('{X}', kwota(krem))) + '</li>');
      if (c.save > 0) li.push('<li>' + OK + esc(t.rabat.replace('{X}', kwota(c.save))) + '</li>');
      const ul = '<ul class="jk-zysk__lista">' + li.join('') + '</ul>';
      el.innerHTML = el.tagName === 'DETAILS'
        ? '<summary class="jk-zysk__gora"><span class="jk-h">' + esc(t.zyskujesz) + '</span>' + (suma > 0 ? '<b class="jk-zysk__kw">' + kwota(suma) + '</b>' : '') + '<span class="jk-zysk__strz" aria-hidden="true">›</span></summary>' + ul
        : '<div class="jk-zysk__gora"><p class="jk-h">' + esc(t.zyskujesz) + '</p>' + (suma > 0 ? '<p class="jk-zysk__suma">' + esc(t.razem).replace('{X}', '<b>' + kwota(suma) + '</b>') + '</p>' : '') + '</div>' + ul;
      el.hidden = !(c.n > 0 && li.length);
    });
  };
  const nazwa = v => { const c = cfg(); return (c && c.t.nazwy && c.t.nazwy[v]) || v; };

  /* ---------- wybór prezentu ---------- */
  document.addEventListener('click', e => {
    if (C0.giftLines) return;
    const k = e.target.closest('.jk-kafel');
    if (!k) return;
    e.preventDefault();
    if (k.getAttribute('aria-disabled') === 'true') return;
    const w = k.dataset.jkWybor, v = k.dataset.jkWartosc, t = T();
    const nowa = k.getAttribute('aria-pressed') === 'true' ? '' : v;
    $$(`.jk-kafel[data-jk-wybor="${w}"]`).forEach(x => x.setAttribute('aria-pressed', String(!!nowa && x.dataset.jkWartosc === nowa)));
    $$(`[data-jk-status="${w}"]`).forEach(st => {
      st.innerHTML = nowa ? zloty(esc(w === '600' ? t.wybrany_1 : t.wybrany_2)).replace('{N}', '<b>' + esc(nazwa(nowa)) + '</b>') : esc(w === '600' ? t.wybierz : t.wybierz_2);
    });
    $$(`[data-jk-drobne="${w}"]`).forEach(d => { d.hidden = !!nowa; });
    if (w === '1500') {
      // R4: „Zyskujesz” = cena wybranego kremu (bez wyboru niższa); suma przeliczana o różnicę
      const c = cfg() || C0, nk = nowa === 'Krem Podopharm do rąk' ? c.kremR : nowa === 'Krem Podopharm do stóp' ? c.kremS : Math.min(c.kremR, c.kremS);
      if (nk) $$('[data-jk-zysk-krem]').forEach(li => { const stare = +li.dataset.kw || 0; li.dataset.kw = nk; li.innerHTML = OK + esc(t.krem_gratis.replace('{X}', kwota(nk)));
        const z = li.closest('[data-jk-slot=zysk]'); if (z) $$('[data-jk-zysk-suma]', z).forEach(b => { const sm = (+b.dataset.kw || 0) - stare + nk; b.dataset.kw = sm; b.textContent = kwota(sm); }); });
    }
    if (w === '600') $$('[data-jk-zysk-prezent]').forEach(li => { li.innerHTML = OK + esc(t.prezent_gratis.replace('{N}', nowa ? nazwa(nowa) : t.do_wyboru)); });
    zapiszAttr({ ['Prezent ' + w]: nowa });
  });

  /* ---------- rekomendacje (Obroty: REKOMENDACJE-93/rekomendacje-snippet.md) ---------- */
  const WYKL_MARKI = ['Lira Clinical', 'Osmosis Beauty', 'Bioelements', 'estGen']; // 1.11.2026: Bioelements i estGen tylko po konsultacji
  const WYKL_TAGI = ['wstrzymane', 'prezent-89', 'prezent', 'bon-podarunkowy', 'bon-na-usluge', 'wysylka-pdf', 'voucher', 'bonykwotowe', 'dodatek-do-zabiegu', 'prezent-koszyk', 'tylko-gabinet'];
  const WYKL_TYPY = ['Bon podarunkowy', 'Voucher podarunkowy', 'Zabieg / usługa', 'Opakowanie prezentowe'];
  const OBSZAR = { 'Włosy': 'wlosy', 'Ciało': 'cialo', 'Dłonie i stopy': 'dlonie-stopy', 'Makijaż': 'makijaz', 'Suplementy': 'suplementy' };
  const obszar = p => OBSZAR[p.type || p.product_type] || 'twarz';
  let danePromise = null;
  const dane = () => danePromise || (danePromise = fetch(C0.rek, { signal: ac.signal }).then(r => r.json()).catch(() => ({})));
  const cacheP = {};
  // R3 N7: pobrania przerywane przy wyjściu ze strony (WebKit zgłaszał je jako błędy), nowe po powrocie z bfcache
  let ac = new AbortController();
  const przerwij = () => ac.abort();
  addEventListener('beforeunload', przerwij);
  addEventListener('pagehide', przerwij);
  addEventListener('pageshow', () => { if (ac.signal.aborted) { ac = new AbortController(); danePromise = null; } });
  const produkt = handle => {
    if (cacheP[handle]) return cacheP[handle];
    const k = 'jrek:' + ROOT + handle;
    try { const s = sessionStorage.getItem(k); if (s) return (cacheP[handle] = Promise.resolve(JSON.parse(s))); } catch (e) {}
    return (cacheP[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { redirect: 'manual', signal: ac.signal }).then(r => (r.ok ? r.json() : null))
      .then(p => { try { if (p) sessionStorage.setItem(k, JSON.stringify(p)); } catch (e) {} return p; }).catch(() => { delete cacheP[handle]; return null; }));
  };
  const dozwolony = (p, wKoszyku) => {
    if (!p || !p.available || !(p.price > 0)) return false;
    if (WYKL_MARKI.includes(p.vendor) || WYKL_TYPY.includes(p.type)) return false;
    if ((p.tags || []).some(t => WYKL_TAGI.includes(String(t).toLowerCase()))) return false;
    return !wKoszyku.has(p.handle);
  };
  const api = async (id, intent) => { try { const r = await fetch(ROOT + 'recommendations/products.json?product_id=' + id + '&limit=10&intent=' + intent, { signal: ac.signal }); return r.ok ? (await r.json()).products || [] : []; } catch (e) { return []; } };
  const naprzemiennie = listy => { const out = []; for (let i = 0; listy.some(l => i < l.length); i++) listy.forEach(l => { if (i < l.length && !out.includes(l[i])) out.push(l[i]); }); return out; };
  const kandydaci = async pozycje => {
    const d = await dane();
    const kom = d.komplementarne || {};
    const handles = naprzemiennie(pozycje.map(it => kom[it.handle] || []));
    const g = pozycje[0];
    if (g) {
      const ob = obszar(g);
      const [c, r] = await Promise.all([api(g.product_id, 'complementary'), api(g.product_id, 'related')]);
      c.forEach(p => handles.push(p.handle));
      r.filter(p => obszar(p) === ob).forEach(p => handles.push(p.handle));
      pozycje.forEach(it => ((d.marka || {})[it.vendor] || []).forEach(h => handles.push(h)));
    }
    (d.bestsellery || []).forEach(h => handles.push(h));
    return [...new Set(handles)];
  };
  const wybierz = async (pozycje, wKoszyku, ile) => {
    const out = [];
    const lista = (await kandydaci(pozycje)).filter(h => !wKoszyku.has(h)).slice(0, 28);
    const prod = await Promise.all(lista.map(produkt));
    const marki = {}; // R3 N6: najwyżej 3 karty jednej marki
    for (const p of prod) {
      if (out.length >= ile) break;
      const m = String((p && p.vendor) || '').toLowerCase();
      if (dozwolony(p, wKoszyku) && (marki[m] || 0) < 3) { out.push(p); marki[m] = (marki[m] || 0) + 1; }
    }
    return out;
  };
  // Domknięcie progu (P bez Lira/Osmosis jak Liquid): najbliższy próg, produkty o cenie ≥ brakującej kwocie idą na początek.
  const domknij = async (cart, c) => {
    const wKoszyku = new Set(cart.items.map(i => i.handle));
    const pozycje = [...cart.items].reverse();
    const prod = await wybierz(pozycje, wKoszyku, 16);
    if (!c.promo || c.waluta !== 'PLN') return { prog: null, produkty: prod.slice(0, 8) };
    const s = stan(c);
    let prog = null, brak = 0;
    if (s.pl && c.d < c.progD) { prog = 'd'; brak = c.progD - c.d; } else if (!s.ok1) { prog = '1'; brak = c.prog1 - c.p; } else if (c.prog2on && !s.ok2 && c.prog2 - c.p <= 40000) { prog = '2'; brak = c.prog2 - c.p; }
    if (!prog) return { prog: null, produkty: prod.slice(0, 8) };
    const cena = p => { const v = (p.variants || []).filter(v => v.available && v.price >= brak).sort((a, b) => a.price - b.price)[0]; return v ? v.price : p.price; };
    const dom = prod.filter(p => cena(p) >= brak && cena(p) <= Math.max(brak * 1.8, brak + 8000)).sort((a, b) => cena(a) - cena(b));
    const reszta = prod.filter(p => !dom.includes(p));
    return { prog: dom.length ? prog : null, produkty: dom.concat(reszta).slice(0, 8), cena };
  };
  const obrazek = (src, w) => { if (!src) return ''; let u = String(src); if (u.startsWith('//')) u = 'https:' + u; return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };
  const kartaProduktu = (p, cenaFn) => {
    const t = T();
    const v = (p.variants || []).find(x => x.available && (!cenaFn || x.price === cenaFn(p))) || (p.variants || []).find(x => x.available) || (p.variants || [])[0];
    const url = ROOT.replace(/\/$/, '') + '/products/' + encodeURIComponent(p.handle);
    return `<div class="jk-pk"><a class="jk-pk__foto" href="${url}" tabindex="-1" aria-hidden="true">${p.featured_image ? `<img src="${esc(obrazek(p.featured_image, 360))}" alt="" width="360" height="360" loading="lazy" decoding="async">` : ''}</a>`
      + `<span class="jk-pk__marka">${esc(p.vendor)}</span><a class="jk-pk__nazwa" href="${url}">${esc(bezMarki(p.title, p.vendor))}</a>`
      + `<span class="jk-pk__cena">${kwota(v ? v.price : p.price)}</span>`
      + `<button type="button" class="jk-pk__dodaj" data-jk-dodaj="${v ? v.id : ''}" aria-label="${esc(t.dodaj.replace('+', '').trim())}: ${esc(p.title)}">${esc(t.dodaj)}</button></div>`;
  };
  let koszykCache = null;
  const koszyk = async () => (koszykCache = await (await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })).json());
  const upsellHTML = {};
  const podpisKoszyka = c => `${c.n}|${c.d}|${c.p}|${c.waluta}`;
  const wypelnijUpsell = async () => {
    const c = cfg();
    if (!c || !c.karta) return;
    // w szufladzie dopiero po otwarciu (bez pobierania rekomendacji na każdej stronie)
    const listy = $$('[data-jk-ups-lista]:not([data-jk-gotowe])').filter(l => { const d = l.closest('cart-drawer'); return !d || d.hasAttribute('open'); });
    if (!listy.length) return;
    const sig = podpisKoszyka(c);
    const wstaw = html => listy.forEach(l => {
      l.dataset.jkGotowe = '1';
      const sek = l.closest('[data-jk-slot=upsell]');
      if (!html.lista) { if (sek) sek.hidden = true; return; }
      l.innerHTML = html.lista;
      const pod = sek && sek.querySelector('[data-jk-ups-pod]');
      if (pod) pod.innerHTML = html.pod || '&nbsp;';
    });
    if (upsellHTML[sig]) return wstaw(upsellHTML[sig]);
    listy.forEach(l => { l.dataset.jkGotowe = '0'; });
    try {
      const cart = await koszyk();
      if (!cart.items.length) return;
      const w = await domknij(cart, c);
      const t = T();
      const html = { lista: w.produkty.map(p => kartaProduktu(p, w.prog ? w.cena : null)).join(''), pod: w.prog ? esc(t['domknij_' + w.prog]) : '' };
      upsellHTML[sig] = html;
      listy.forEach(l => { delete l.dataset.jkGotowe; });
      if (podpisKoszyka(cfg()) === sig) wstaw(html);
    } catch (e) { listy.forEach(l => { delete l.dataset.jkGotowe; }); }
  };

  /* ---------- dodanie z kart rekomendacji (bez przeładowania) ---------- */
  let wlasne = false;
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-jk-dodaj]');
    if (!b || !b.dataset.jkDodaj) return;
    e.preventDefault();
    if (b.dataset.stan === 'ok') return;
    b.setAttribute('aria-busy', 'true');
    try {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
      const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-JK': '1' },
        body: JSON.stringify({ items: [{ id: Number(b.dataset.jkDodaj), quantity: 1 }], sections, sections_url: location.pathname }) });
      const j = await r.json();
      if (j.status) throw new Error(j.description || 'add');
      const cart = await koszyk();
      cart.sections = j.sections;
      b.dataset.stan = 'ok';
      b.textContent = T().dodane;
      wlasne = true;
      try { FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart }); } catch (err) {}
      wlasne = false;
      setTimeout(() => { odswiez(); progKarty(); }, 80);
    } catch (err) {
      b.textContent = T().dodaj;
    } finally { b.removeAttribute('aria-busy'); }
  });

  /* ---------- karta „Dodano do koszyka” ---------- */
  let karta = null, powrot = null;
  const IKONA_X = '<svg viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M3.5 3.5l11 11M14.5 3.5l-11 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
  const szkielet = () => '<div class="jk-pk jk-pk--szkielet" aria-hidden="true"><span class="jk-pk__foto"></span><span class="jk-pk__marka">&nbsp;</span><span class="jk-pk__nazwa">&nbsp;</span><span class="jk-pk__cena">&nbsp;</span><span class="jk-pk__dodaj">&nbsp;</span></div>'.repeat(3);
  const zbudujKarte = () => {
    const t = T();
    karta = document.createElement('div');
    karta.className = 'jk jk-karta';
    karta.setAttribute('role', 'dialog');
    karta.setAttribute('aria-modal', 'true');
    karta.setAttribute('aria-labelledby', 'jk-karta-h');
    karta.innerHTML = `<div class="jk-karta__tlo" data-jk-zamknij></div><div class="jk-karta__panel" data-jk-panel>
      <div class="jk-karta__chwyt" data-jk-chwyt aria-hidden="true"></div>
      <div class="jk-karta__gora" data-jk-chwyt><p class="jk-h jk-karta__tytul" id="jk-karta-h">${zloty(esc(t.dodano))}</p>
      <button type="button" class="jk-karta__x" data-jk-zamknij aria-label="${esc(t.zamknij)}">${IKONA_X}</button></div>
      <div class="jk-karta__tresc" data-jk-tresc>
        <div class="jk-karta__poz" data-jk-poz></div>
        <p class="jk-karta__prog" data-jk-karta-prog hidden></p>
        <div class="jk-karta__przyciski"><button type="button" class="jk-btn jk-btn--ramka" data-jk-koszyk>${esc(t.koszyk)}</button>
          <a class="jk-btn jk-btn--zloto" href="/checkout" data-jk-kasa>${esc(t.do_kasy)}</a></div>
        <section class="jk-karta__reko" aria-labelledby="jk-reko-h"><h3 class="jk-h" id="jk-reko-h">${esc(t.reko)}</h3><p class="jk-pod">${esc(t.reko_pod)}</p>
          <div class="jk-rzad jk-ups__lista" data-jk-reko-lista></div></section>
      </div></div>`;
    document.body.appendChild(karta);
    karta.addEventListener('click', e => {
      if (e.target.closest('[data-jk-zamknij]')) { e.preventDefault(); zamknij(); return; }
      if (e.target.closest('[data-jk-koszyk]')) {
        e.preventDefault();
        zamknij(false);
        const dr = document.querySelector('cart-drawer');
        if (dr && typeof dr.show === 'function') { dr.show(); } else { location.href = ROOT + 'cart'; }
      }
    });
    // Escape z całego dokumentu (Safari nie przenosi fokusu na kliknięty przycisk)
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && karta.hasAttribute('data-otwarta')) { e.preventDefault(); zamknij(); } });
    karta.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const f = $$('button:not([disabled]),a[href]:not([tabindex="-1"])', karta).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      const i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    });
    // gest w dół (uchwyt, nagłówek albo treść przewinięta do góry)
    const panel = karta.querySelector('[data-jk-panel]'), tresc = karta.querySelector('[data-jk-tresc]');
    let y0 = null, dy = 0;
    panel.addEventListener('touchstart', e => {
      if (window.matchMedia('(min-width:750px)').matches) return;
      const zChwytu = !!e.target.closest('[data-jk-chwyt]');
      if (!zChwytu && (tresc.scrollTop > 0 || e.target.closest('.jk-rzad'))) return;
      y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none';
    }, { passive: true });
    panel.addEventListener('touchmove', e => {
      if (y0 == null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      panel.style.setProperty('--jk-dy', dy + 'px');
    }, { passive: true });
    panel.addEventListener('touchend', () => {
      if (y0 == null) return;
      y0 = null; panel.style.transition = '';
      if (dy > 90) zamknij(); else panel.style.setProperty('--jk-dy', '0px');
    });
  };
  const zamknij = (oddajFokus = true) => {
    if (!karta || !karta.hasAttribute('data-otwarta')) return;
    karta.removeAttribute('data-otwarta');
    karta.querySelector('[data-jk-panel]').style.setProperty('--jk-dy', '0px');
    document.documentElement.classList.remove('jk-zablokuj');
    if (oddajFokus && powrot && powrot.focus) { try { powrot.focus({ preventScroll: true }); } catch (e) {} }
  };
  const progKarty = () => {
    if (!karta || !karta.hasAttribute('data-otwarta')) return;
    const el = karta.querySelector('[data-jk-karta-prog]');
    const c = cfg();
    if (!c || !c.promo || !c.n) { el.hidden = true; return; }
    const s = stan(c), t = c.t;
    let txt;
    if (s.pl && c.d < c.progD) txt = t.prog_d.replace('{X}', '<b>' + kwota(c.progD - c.d) + '</b>');
    else if (!s.ok1) txt = (s.pl ? t.prog_1 : t.dodaj_wybierz).replace('{X}', '<b>' + kwota(s.p1 - c.p) + '</b>');
    else if (c.prog2on && !s.ok2) txt = t.prog_2.replace('{X}', '<b>' + kwota(s.p2 - c.p) + '</b>');
    else txt = c.prog2on ? t.masz_dwa : t.masz_prezent;
    // R4: prezent do wyboru (próg osiągnięty, nic nie wybrane) → złoty przycisk prowadzi do koszyka z kafelkami, nie do kasy
    const do1 = s.ok1 && !attr(c, 'Prezent 600'), do2 = s.ok2 && s.pl && !attr(c, 'Prezent 1500');
    const kasa = karta.querySelector('[data-jk-kasa]');
    if (do1 || do2) { txt = !s.ok2 ? t.karta_wybierz : do1 ? t.karta_wybierz_2 : t.karta_wybierz_drugi; kasa.href = ROOT + 'cart#jk-prez-h-cart'; kasa.textContent = t.wybierz_btn; }
    else { kasa.href = '/checkout'; kasa.textContent = t.do_kasy; }
    if (c.p <= 0 && !(s.pl && c.d < c.progD)) { el.hidden = true; return; }
    el.innerHTML = zloty(txt);
    el.hidden = false;
  };
  const otworzKarte = async item => {
    if (!karta) zbudujKarte();
    const t = T();
    powrot = document.activeElement;
    const wariant = item.variant_title && !/default title/i.test(item.variant_title) ? item.variant_title : '';
    karta.querySelector('[data-jk-poz]').innerHTML = `<span class="jk-karta__mini">${item.image ? `<img src="${esc(obrazek(item.image, 160))}" alt="" width="64" height="64">` : ''}</span>
      <span><span class="jk-karta__marka" style="display:block">${esc(item.vendor)}</span><span class="jk-karta__nazwa">${esc(bezMarki(item.product_title || item.title, item.vendor))}</span>
      ${wariant ? `<span class="jk-karta__wariant" style="display:block">${esc(wariant)}</span>` : ''}<span class="jk-karta__cena" style="display:block">${kwota(item.final_price != null ? item.final_price : item.price)}</span></span>`;
    const lista = karta.querySelector('[data-jk-reko-lista]');
    lista.innerHTML = szkielet();
    karta.querySelector('[data-jk-karta-prog]').hidden = true;
    karta.querySelector('[data-jk-tresc]').scrollTop = 0;
    document.documentElement.classList.add('jk-zablokuj');
    requestAnimationFrame(() => { karta.setAttribute('data-otwarta', ''); karta.querySelector('.jk-karta__x').focus({ preventScroll: true }); });
    setTimeout(progKarty, 120);
    try {
      const cart = await koszyk();
      const wKoszyku = new Set(cart.items.map(i => i.handle));
      const pozycje = [item].concat(cart.items.filter(i => i.key !== item.key).reverse());
      const prod = await wybierz(pozycje, wKoszyku, 8);
      if (prod.length) lista.innerHTML = prod.map(p => kartaProduktu(p)).join('');
      else lista.closest('.jk-karta__reko').hidden = true;
    } catch (e) { lista.closest('.jk-karta__reko').hidden = true; }
  };
  document.addEventListener('product-ajax:added', e => {
    const c = cfg();
    if (!c || !c.karta || wlasne) return;
    const prod = e.detail && e.detail.product;
    const item = prod && (Array.isArray(prod.items) ? prod.items[0] : prod);
    if (!item || !item.product_id) return;
    const dr = document.querySelector('cart-drawer');
    if (dr && dr.open) return; // dodanie z wnętrza otwartej szuflady: zostaje szuflada
    if (dr) {
      // motyw zaraz woła drawer.show(): jednorazowo zastępujemy to kartą (szuflada dalej działa z ikony koszyka)
      dr.show = function () { delete dr.show; };
      setTimeout(() => { if (Object.prototype.hasOwnProperty.call(dr, 'show')) delete dr.show; }, 4000);
    }
    otworzKarte(item);
  });

  // Karty produktów marek (sections/*-pdp.liquid, egAddToCart) dodają własnym fetch('/cart/add.js') z dymkiem #egToast,
  // bez zdarzeń motywu i bez odświeżenia szuflady. Łapiemy udane dodanie JSON bez „sections” (formularze motywu wysyłają
  // sections i mają własne zdarzenie product-ajax:added), odświeżamy szufladę i pokazujemy kartę zamiast dymka.
  const fetch0 = window.fetch;
  window.fetch = function (input, init) {
    const p = fetch0.apply(this, arguments);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const body = init && typeof init.body === 'string' ? init.body : null;
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && String(init.method).toUpperCase() === 'POST' && body && !/"sections"/.test(body) && !(init.headers && init.headers['X-JK'])) {
        p.then(r => (r.ok ? r.clone().json() : null)).then(it => {
          const c = cfg();
          const item = it && (Array.isArray(it.items) ? it.items[0] : it);
          if (!item || !item.product_id) return;
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
          if (c && c.karta) otworzKarte(item);
        }).catch(() => {});
      }
    } catch (e) {}
    return p;
  };

  /* ---------- odświeżanie po zmianach koszyka (Section Rendering API podmienia HTML) ---------- */
  let zaplanowane = false;
  const odswiez = () => { przelicz(); synchronizuj(); wypelnijUpsell(); };
  const planuj = () => { if (zaplanowane) return; zaplanowane = true; queueMicrotask(() => { zaplanowane = false; odswiez(); }); };
  new MutationObserver(muts => {
    for (const m of muts) for (const n of m.addedNodes) {
      if (n.nodeType === 1 && (n.matches('[data-jk-cfg],[data-jk-slot]') || n.querySelector('[data-jk-cfg],[data-jk-slot]'))) { planuj(); progKarty(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('cart:updated', () => setTimeout(odswiez, 50));
  const dr0 = document.querySelector('cart-drawer');
  if (dr0) new MutationObserver(() => { if (dr0.hasAttribute('open')) { zamknij(false); wypelnijUpsell(); } }).observe(dr0, { attributes: true, attributeFilter: ['open'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', odswiez); else odswiez();
})();
